import React from "react";
import { useAccountDropDown } from "../../Pregrine/AccountDropDown/useAccountDropDown";
import classes from "./accountDropDown.module.css";
import { Link } from "react-router-dom";

const AccountDropDown = (props) => {
  const { handleAccountTrigger, accountRef, accountIsOpen } = props;
  const talonProps = useAccountDropDown({ handleAccountTrigger });
  const { handleLogout, menuItems } = talonProps;

  const menu = menuItems.map((item) => {
    return (
      <li key={item.name} className={classes.rootli}>
        <Link className={classes.link} to={item.url}>
          <span>{item.name}</span>
        </Link>
      </li>
    );
  });

  return (
    <>
      {accountIsOpen ? (
        <ul ref={accountRef} className={classes.root}>
          {menu}
          <li className={classes.rootli}>
            <button
              className={classes.signOut}
              onClick={handleLogout}
              type="button"
            >
              Sign Out
            </button>
          </li>
        </ul>
      ) : null}
    </>
  );
};

export default AccountDropDown;
